import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { addPaymentUserOffice } from "../../helper/API/paymentTaskByAdvocate";
import { toast } from "react-toastify";

const OfficeModal = ({ show, handleClose, refresh, setRefresh }) => {
  const [label, setLabel] = React.useState("");

  const handleNameSubmit = () => {
    const submitData = { label };
    addPaymentUserOffice(submitData).then(res => {
      // console.log("res add Office", res);
      if (res.success) {
        setRefresh(refresh + 1);
        handleClose();
      } else {
        toast.error(res.message);
      }
    });
  };
  return (
    <div>
      <Dialog open={show} onClose={handleClose}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          <div>Cargo </div>
          <div>
            <CloseIcon onClick={handleClose} />
          </div>
        </DialogTitle>
        <DialogContent sx={{ minWidth: "420px", display: "flex", mt: 3, mb: 3, justifyContent: "space-around" }}>
          <TextField id="outlined-basic" label="Cargo" variant="outlined" sx={{ mt: 2 }} onChange={e => setLabel(e.target.value)} />
          <Button variant="contained" sx={{ mt: 2 }} onClick={handleNameSubmit}>
            Salvar
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default OfficeModal;
